import { LANGUAGE_FILTER_OPTIONS } from "@/search/NewSearchPageMVP/NewSearchPageMVP.constants";
import { FilterSection } from "@/search/NewSearchPageMVP/shared/FilterSection";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";
import { RadioFilter } from "../../../shared/RadioFilter";

export const Language = () => {
  return (
    <FilterSection title="Language" defaultCollapsed={false}>
      <RadioFilter
        options={LANGUAGE_FILTER_OPTIONS}
        paramName={AgathaSchemaParamsEnum.language}
      />
    </FilterSection>
  );
};
